import { render } from "./PersonalLogin.vue?vue&type=template&id=64af12a8&scoped=true"
import script from "./PersonalLogin.vue?vue&type=script&lang=js"
export * from "./PersonalLogin.vue?vue&type=script&lang=js"

import "./PersonalLogin.vue?vue&type=style&index=0&id=64af12a8&lang=scss&scoped=true"
import "./PersonalLogin.vue?vue&type=style&index=1&id=64af12a8&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-64af12a8"]])

export default __exports__